import React from "react";

import "./Body.scss";

export const Body: React.FC = ({ children }) => {
  return <div className="Body">{children}</div>;
};
